import classNames from 'classnames';
import { IconProps, UI_Icon } from '../../Media/Icon/Icon';
import { LinkProps, UI_Link } from '../Link/Link';
import styles from './LinkWithIcon.module.scss';

export interface LinkWithIconProps extends LinkProps {
	className?: string;
	icon: React.ReactNode;
	text: string;
	hideTextOnMobile?: boolean;
	iconDropShadow?: boolean;
	iconAutoWidth?: boolean;
	iconSize?: IconProps['size'];
	gap?: 'small';
	reverseOrder?: boolean;
	alignToTop?: boolean;
}

export const UI_LinkWithIcon = ({
	className,
	icon,
	text,
	hideTextOnMobile,
	iconDropShadow,
	iconAutoWidth,
	iconSize = 'sm',
	gap,
	reverseOrder,
	alignToTop,
	...linkProps
}: LinkWithIconProps) => {
	return (
		<UI_Link
			className={classNames(
				styles.LinkWithIcon,
				{
					[styles.LinkWithIcon___hideTextOnMobile]: hideTextOnMobile,
					[styles.LinkWithIcon___reverseOrder]: reverseOrder,
					[styles.LinkWithIcon___smallGap]: gap == 'small',
					[styles.LinkWithIcon___alignToTop]: alignToTop,
				},
				className,
			)}
			{...linkProps}
		>
			<span className={styles.LinkWithIcon_text}>{text}</span>
			<UI_Icon
				aria-label={hideTextOnMobile && text}
				size={iconSize}
				ariaHidden
				className={classNames(styles.LinkWithIcon_icon, {
					[styles.LinkWithIcon_icon___dropShadow]: iconDropShadow,
					[styles.LinkWithIcon_icon___autoWidth]: iconAutoWidth,
				})}
			>
				{icon}
			</UI_Icon>
		</UI_Link>
	);
};
